import React, { useEffect } from 'react';
import { BsGithub } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import mahbubImg from "../../assets/images/bg_mahbub (8).png";
import LogoSlider from './LogoSlider';
import { Link } from 'react-router-dom';

const Header = () => {
    useEffect(() => {
        document.title = "Munir Uddin Mahbub | Full MERN-Stack Web Developer || munir uddin mahbub, Handsome boy, handsome boy in the Bangladesh handsome boy in bd, handsome boy in bangladash talented boy"
    }, [])
    return (
        <div className=" md:pb-20 pb-10">
            <div className='container mx-auto lg:px-0 px-2 md:text-left text-center'>
                <div className="grid grid-cols-2 gap-4">
                    <div className='md:col-span-1 col-span-2 grid content-center'>
                        <h3 className='text-2xl font-semibold font-poppins py-2 text-[#F95025]'>Hello, I'm</h3>
                        <h1 className=' text-xl lg:text-4xl font-bold font-poppins py-1'>Munir Uddin Mahbub</h1>
                        <h5 className="text-lg font-poppins font-semibold py-2">
                            Full MERN-Stack <span className="text-[#01b944]">Web Developer</span> Form <span className="text-purple-500">Bangladash</span>
                        </h5>
                        <p className="text-gray-700 font-poppins">
                            Web Design & Development is my passion, I get deeper to understand client's need & problems. My mission is to satisfy every client and become myself a pro developer to learn new updates every day. You'll get lifetime support in any situation, I Premise that, You'll get Fanatical Support and Absolutely Positively On-time Delivery.
                        </p>
                        <div className="flex md:justify-start justify-center py-4 gap-4">
                            <Link to="/contact" >
                                <button className="py-1.5 px-4 font-poppins text-sm rounded-full text-white bg-[#F64E23]">Contact Me</button>
                            </Link>
                            <div className='flex gap-1 items-center'>
                                <a href="https://github.com/mahbub-hasan2" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-1' >
                                    <BsGithub className="text-xl" />
                                </a>
                                <a href="https://linkedin.com/in/mahbubdev1" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-1' >
                                    <AiFillLinkedin className="text-xl" />
                                </a>
                                <a href="https://youtube.com/@mahbubdev" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-1' >
                                    <AiFillYoutube className="text-xl" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <!-- ...--- --> */}
                    <div
            
                        className=' relative md:col-span-1 col-span-2 md:order-none order-first grid content-center justify-center'
                    >
                        <div className="w-full h-full">
                            <img className='md:h-full h-full w-full object-cover' src={mahbubImg} alt="munir uddin mahbub, Handsome boy, handsome boy in the Bangladesh handsome boy in bd, handsome boy in bangladash talented boy" />
                            {/* <img className='md:h-full h-full w-full object-cover' src={mahbub} alt="" /> */}

                        </div>
                        <div className="">
                            {/* <Video/> */}
                        </div>
                        <div className="shadow-md hidden md:block rounded-full px-10 py-2 absolute -bottom-7 right-0 bg-[#fffdff8c] w-full">
                            <LogoSlider />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;